import useTableColumnBuilder from "hooks/useTableColumnBuilder";
import { IConfigCSVErrors } from "domain/Config/Models/IConfigCSVErrors";

export const useInventoryPositionUploadErrorsHeader = () => {
	const { add, build } = useTableColumnBuilder<IConfigCSVErrors>();

	add({
		id: () => "errors",
		name: "uploadErrorsTitle",
		headers: [
			{
				id: (c) => c.field ?? "",
				key: "field",
				name: "Field",
				maxWidth: "200px",
			},
			{
				id: (c) => (c.lines ?? []).join(", "),
				key: "lines",
				name: "Lines",
				maxWidth: "200px",
			},
			{
				id: (c) => c.description ?? "",
				key: "description",
				name: "Error Message",
				maxWidth: "400px",
			},
		],
	});

	return { headers: build() };
};

export default useInventoryPositionUploadErrorsHeader;
